import { useMutation, useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';

import type { NormalizedApiError } from '@/shared/api';

import * as mediaApi from './api/mediaApi';
import type { AssetResponse, MediaOwnerType, MediaVisibility, UploadAssetParams } from './model/types';

type Opts = { enabled?: boolean };
type Err = NormalizedApiError;

export const mediaKeys = {
  all: ['media'] as const,
  assets: (params: { ownerType: MediaOwnerType; ownerId?: string; visibility?: MediaVisibility }) =>
    ['media', 'assets', params] as const,
};

export function useUploadAsset() {
  return useMutation<AssetResponse, Err, UploadAssetParams>({
    mutationFn: (params) => mediaApi.uploadAsset(params),
  });
}

export function useMediaAssets(
  params: { ownerType: MediaOwnerType; ownerId?: string; visibility?: MediaVisibility },
  options?: Opts,
): UseQueryResult<AssetResponse[], Err> {
  return useQuery<AssetResponse[], Err>({
    queryKey: mediaKeys.assets(params),
    queryFn: () => mediaApi.listAssets(params),
    enabled: options?.enabled ?? true,
    staleTime: 30_000,
    retry: 1,
  });
}
